import React from "react";
import { htmlDecode } from "../../utils";
import DOMPurify from 'dompurify';

class SigningText extends React.Component {
    constructor(props) {
        super(props)
    }

    render() {
        return (
            <>
                { window.images.signingText && window.images.signingImage &&
                    <div className="row justify-content-md-center">
                        <div className="col-12 col-sm-4 col-md-4 col-lg-3 p-5">
                            <img className="img-responsive" src={window.images.signingImage} />
                        </div>
                        <div className="col-12 col-sm-8 col-md-6 col-lg-6 p-5">
                            <div className="vertical-center" dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(htmlDecode(window.images.signingText))}}></div>
                        </div>
                    </div>
                }
            </>
        )
    }
}

export default SigningText



